import {ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener, NgZone, OnDestroy, Renderer2} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractImageInput} from "../abstract-image-input";
import {Subscription} from "rxjs";
import {FUIEventsService} from "../../../../events/events.service";
@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineImageInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-image-input",
    styleUrls: ["./inline-image-input.component.scss"],
    templateUrl: "./inline-image-input.component.html",
    standalone: false
})
export class FUIInlineImageInputComponent extends FUIAbstractImageInput implements OnDestroy {
    private _$click: Subscription;
    private _popped: boolean;
    private clicking = false;

    constructor(changeDetectorRef: ChangeDetectorRef,
                element: ElementRef,
                ngZone: NgZone,
                private eventsService: FUIEventsService,
                renderer: Renderer2) {
        super(changeDetectorRef, element, ngZone, renderer);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this._$click = this.eventsService.click$.subscribe(
            (click) => {
                if (!this.clicking && this.popped && !this.element.nativeElement.contains(click.target)) {
                    this.popped = false;
                }
            }
        )
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this._$click.unsubscribe();
    }

    /**
     *
     * @returns {boolean}
     */
    get popped(): boolean {
        return this._popped;
    }

    /**
     *
     * @param {boolean} popped
     */
    set popped(popped: boolean) {
        this._popped = popped;
        this.focussed = popped;
        this.focussed$.emit(this.focussed);
    }

    /**
     *
     * @param {boolean} popped
     */
    public pop(popped: boolean): void {
        this.popped = popped;
    }

    /**
     * Click action is different to other controls, it only wants to pop up it's dropdown, not focus on the underlying input
     */
    public override click(): void {
        this.clicking = true;
        setTimeout(() => this.clicking = false);
        this.popped = !this.popped;
    }

    /**
     * If a user presses enter or space while focussed on the element,
     * use the click method to apply the relevant interaction
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    public override keypress(keyboardEvent: KeyboardEvent) {
        if (!this.disabled) {
            if (keyboardEvent.code === "Enter" || keyboardEvent.code === "Space" || keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
                this.click();
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
            }
        }
    }
}
